<template>
  <section class="cool-confirm" :class="confirm.class || ''">
    <transition name="confirm">
      <div class="mask" v-if="animationShow">
        <div class="confirm-wrap">
          <div class="confirm-title" v-show="confirm.title">{{confirm.title}}</div>
          <div class="confirm-content" :class="{'has-title': confirm.title, 'text-left': confirm.textLeft}" v-html="confirm.content"></div>
          <div class="confirm-footer">
            <button class="cancel-btn" v-show="!confirm.noCancel" @click="cancel">{{confirm.cancelBtn}}</button>
            <button class="confirm-btn" color-primary v-show="!confirm.noConfirm" @click="clickConfirm">{{confirm.confirmBtn}}</button>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>

const CONFIRM = {
  title: '',
  content: '',
  textLeft: false,
  noCancel: false,
  noConfirm: false,
  cancelBtn: '取消',
  cancelHandler() {},
  confirmBtn: '确定',
  confirmHandler() {},
  hasConfirm() {}
}
export default {
  name: 'confirm',
  components: {},
  data() {
    return {
      animationShow: false,
      confirm: {
        content: '',
        noCancel: false,
        noConfirm: false,
        cancelBtn: '取消',
        cancelHandler() {},
        confirmBtn: '确定',
        confirmHandler() {},
        hasConfirm() {}
      }
    }
  },
  computed: {},
  methods: {
    clickConfirm() {
      this.confirm.confirmHandler()
      this.hide()
    },
    cancel() {
      this.confirm.cancelHandler()
      this.hide()
    },
    hide() {
      this.animationShow = false
      this.$emit('confirmHide')
    }
  },
  mounted() {
    this.$on('showConfirm', confirm => {
      if (this.animationShow) {
        this.confirm.hasConfirm()
        return
      }
      this.confirm = Object.assign({}, CONFIRM, confirm)
      this.animationShow = true
      // console.log('showConfirm', this.confirm)
    })
    this.$on('hideConfirm', data => {
      this.hide()
    })
  },
  created() {
  }
}
</script>

<style scoped lang="scss">
@import "../style/cool.practical";
.cool-confirm{
  .mask{
    @extend %all-mask;
    @extend %flex-center;
  }
  .confirm-wrap{
    min-width: 520px;
    max-width: 560px;
    /*max-height: 400px;*/
    background-color: #fff;
    border-radius: 10px;
    .confirm-title{
      text-align: center;
      padding-top: 40px;
      font-weight: 500;
    }
    .confirm-content{
      min-height: 170px;
      padding: 30px 40px;
      text-align: center;
      @extend %flex-center;
      &.has-title{
        min-height: 110px;
        padding-top: 20px;
        color: #666666;
      }
      &.text-left{
        text-align: left;
      }
    }
    .confirm-footer{
      height: 90px;
      width: 100%;
      border-top: 1px solid $border-bottom-color;
      @extend %flex-space-between;
      button{
        flex: 1;
        text-align: center;
        font-size: 32px;
        height: 100%;
        &:nth-child(1){
          border-right: 1px solid $border-bottom-color;
        }
      }
      .cancel-btn{
        color: #999999;
      }
      .confirm-btn{
      }
    }
  }
  .confirm-enter-active, .confirm-leave-active {
    transition: opacity .3s;
    .confirm-wrap{
      /*transition: transform .4s*/
    }
  }
  .confirm-enter{
    opacity: 0;
    .confirm-wrap{
      /*transform: translateY(100%);*/
    }
  }
  .confirm-enter-to{
    opacity: 1;
    .confirm-wrap{
      /*transform: translateY(0);*/
    }
  }
  .confirm-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    .confirm-wrap{
      /*transform: translateY(100%);*/
    }
  }
}
</style>
